import message from './Message';

export default message;
